import React, { useState, useContext } from 'react';
import { Bell, Save } from 'lucide-react';
import axios from 'axios';
import AppContext from '../../../context/AppContext';
import Swal from 'sweetalert2';
import '../../../assets/css/admin/adminSettings/adminnotificationsettings.css';

const AdminNotificationSettings = () => {
  const { baseUrl, authToken } = useContext(AppContext);

  const [notifications, setNotifications] = useState({
    inAppNotifications: true,
    emailNotifications: true
  });

  return (
    <div className="adm-notif-container">
      <div className="adm-notif-wrapper">
        <div className="adm-notif-page-header">
          <Bell size={28} className="adm-notif-header-icon" />
          <h2 className="adm-notif-page-title">Notification Settings</h2>
        </div>

        <div className="adm-notif-settings-card">
          <div className="adm-notif-card-header">
            <Bell size={24} className="adm-notif-card-icon" />
            <h4 className="adm-notif-card-title">Manage Your Notifications</h4>
          </div>

          {/* In-app Notifications */}
          <div className="adm-notif-section">
            <h6 className="adm-notif-section-title">In-app Notifications</h6>
            <p className="adm-notif-section-description">
              Receive notifications within the admin panel about bookings, payments, and updates
            </p>

            <div className="adm-notif-toggle-item">
              <div className="adm-notif-toggle-info">
                <span className="adm-notif-toggle-label">Enable In-app Notifications</span>
                <span className="adm-notif-toggle-description">
                  Get instant notifications about bookings, payments, and important system updates
                </span>
              </div>
              <div
                className={`adm-notif-toggle-switch ${notifications.inAppNotifications ? 'adm-notif-active' : ''}`}
                onClick={() =>
                  setNotifications(prev => ({ ...prev, inAppNotifications: !prev.inAppNotifications }))
                }
              >
                <div className="adm-notif-toggle-slider" />
              </div>
            </div>
          </div>

          <button
            className="adm-notif-save-button"
            onClick={() => {
              axios
                .post(
                  `${baseUrl}/admin/admin-notification-settings`,
                  {
                    in_app_notifications: notifications.inAppNotifications ? 1 : 0
                  },
                  {
                    headers: {
                      Authorization: `Bearer ${authToken}`
                    }
                  }
                )
                .then(response => {
                  Swal.fire('Success', response.data.message, 'success');
                })
                .catch(error => {
                  console.log(error);
                  Swal.fire('Error', 'Failed to save notification settings', 'error');
                });
            }}
          >
            <Save size={18} />
            Save Preferences
          </button>
        </div>
      </div>
    </div>
  );
};

export default AdminNotificationSettings;